import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import {
  urlCheckExpeditionProcessSecured,
  urlExpeditionProcessSecured,
  urlExpeditionProcessStatusSecured,
  urlExportExpeditionProcessSecured,
  urlOnlyExpeditionProcessSecured,
} from "../../api/urls";
import moment from "moment-timezone";

const generateExpeditionProcessFilterQuery = ({
  filters,
  page,
  pageSize,
  sort,
}) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.status) filter += "&status=" + filters.status;
    if (filters.batch) filter += "&batch=" + filters.batch;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter list stock.
 */
export const filterExpeditionProcess = createAction(
  "FILTER_EXPEDITION_PROCESS",
  (filter, param) =>
    apiGet(
      urlExpeditionProcessSecured +
        generateExpeditionProcessFilterQuery(filter),
      param,
      true,
    )(),
);

/**
 * Export Inventary.
 */
export const listExpeditionProcessToExport = createAction(
  "EXPORT_FILTER_EXPEDITION_PROCESS",
  (param) => apiGet(urlExportExpeditionProcessSecured, param, true)(),
);

export const createExpeditionProcess = createAction(
  "CREATE_EXPEDITION_PROCESS",
  (obj) => apiPost(urlExpeditionProcessSecured, obj, undefined, true)(),
);

export const getProcess = createAction("GET_PROCESS", (param) =>
  apiGet(urlExpeditionProcessSecured, param, true)(),
);

export const modifyExpeditionProcess = createAction(
  "MODIFY_EXPEDITION_PROCESS",
  (param) => apiPut(urlExpeditionProcessSecured, undefined, param, true)(),
);

export const bbsNew = createAction("CREATE_INVENTARY", (obj, param) =>
  apiPost(urlOnlyExpeditionProcessSecured, obj, param, true)(),
);

export const modifyProcessStatus = createAction("MODIFY_STATUS_PROCESS", (param, obj) =>
  apiPut(urlExpeditionProcessStatusSecured, obj, param, true)(),
);

export const itemRemove = createAction("DELETE_ITEM", (param) =>
  apiDelete(urlOnlyExpeditionProcessSecured, param, true)(),
);


export const check = createAction("CREATE_INVENTARY", (obj) =>
  apiPost(urlCheckExpeditionProcessSecured, obj, undefined, true)(),
);

export const modifyProcess = createAction("MODIFY_PROCESS", (uuid, values) =>
  apiPut(urlExpeditionProcessSecured, values, uuid, true)(),
);

